import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';

interface LabelWithInfoProps {
    label: string;
    helperText: string;
  }

  const LabelWithInfo: React.FC<LabelWithInfoProps> = ({ label, helperText }) => {
    const op = useRef<OverlayPanel>(null);

  return (
    <div style={{ marginBottom: '0.2rem' }}>
      <label style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
        {label}
        <Button
          style={{
            marginLeft: '0.4rem',
            padding: '0.15rem',
            width: '1.2rem',
            height: '1.2rem',
            fontSize: '0.65rem'
          }}
          type="button"
          icon="pi pi-info-circle"
          className="p-button-text p-button-sm p-button-rounded"
          onMouseOver={(e) => {
            if (op.current) {
              op.current.show(e, e.target);
            }
          }}
          onMouseLeave={() => {
            if (op.current) {
              op.current.hide();
            }
          }}
        />
      </label>
      <OverlayPanel ref={op} style={{maxWidth: '15rem'}}>
        <label>{helperText}</label>
      </OverlayPanel>
    </div>
  );
};

export default LabelWithInfo;